import React, { ReactNode, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import compact from 'lodash/compact'

import IconArrowDown from 'client/icons/ArrowDown'
import IconArrowUp from 'client/icons/ArrowUp'
import useToggle from 'src/hooks/useToggle'

import messages from './messages'
import { ShowMoreBase } from './styles'

interface Props {
  children: ReactNode
  blocksToShow?: number
  showAll?: boolean
}

const DEFAULT_BLOCKS_TO_SHOW = 2

const ShowMore = ({ children, blocksToShow = DEFAULT_BLOCKS_TO_SHOW, showAll = false }: Props) => {
  const { value: toggled, toggle } = useToggle({ value: false })

  const childrenWithContent = useMemo(() => {
    return compact(React.Children.toArray(children))
  }, [children])

  const showChildren = useMemo(() => {
    return toggled || showAll ? childrenWithContent : childrenWithContent.slice(0, blocksToShow)
  }, [toggled, childrenWithContent, blocksToShow, showAll])

  const translation = toggled ? messages.showLess : messages.showMore

  return (
    <>
      {showChildren}
      {childrenWithContent.length > blocksToShow && !showAll && (
        <ShowMoreBase onClick={toggle}>
          <FormattedMessage {...translation} />
          {toggled ? <IconArrowUp /> : <IconArrowDown />}
        </ShowMoreBase>
      )}
    </>
  )
}

export default ShowMore
